import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "@jti/ui";
import { HistoryTableRow } from "./HistoryTableRow/HistoryTableRow";
import { TableHeading } from "./TableHeading/TableHeading";
import getEventDisplayName from "./util/getEventDisplayName";
import styles from "./HistoryTable.module.scss";
export const HistoryTable = ({ rows, labels, variant, pointsUnit, eventMessages }) => {
    const isReferral = variant === "referral";
    const { __ } = useTranslations();
    return (_jsxs("table", { "data-testid": "history-table", className: styles.historyTable, children: [_jsx(TableHeading, { ...labels, isReferral: isReferral }), _jsx("tbody", { children: rows.map((singleElement, index) => {
                    const isBalanceAvailable = "balance" in singleElement;
                    const status = isBalanceAvailable
                        ? singleElement.type === "PointsWereAdded" || singleElement.type === "PointsWereRefunded"
                        : true;
                    return (_jsx(HistoryTableRow, { labels: labels, date: singleElement.date, event: isReferral
                            ? __(singleElement.event)
                            : getEventDisplayName(singleElement, eventMessages), points: `${singleElement.points} ${pointsUnit ? " " + pointsUnit : ""}`, balance: isBalanceAvailable ? singleElement.balance : undefined, status: status, isReferral: isReferral }, index));
                }) })] }));
};
//# sourceMappingURL=HistoryTable.js.map